import {getToken, setToken} from "@/utils/auth";

const state = {
  dzhToken: getToken(),
}

const mutations = {
  SET_DZH_TOKEN: (state, token) => {
    state.dzhToken = token
  }
}

const actions = {
  setDzhToken({ commit }, token) {
    commit('SET_DZH_TOKEN', token)
    setToken(token);
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
